const shippingTypeCorrespondance = {
    'Mondial Relay': 'mondial-relay',
    'Domicile': 'standard',
    'Express': 'express',
    'Tous': 'tous'
};
const getDetails = (promotion, customer) => {
    try {
        let shippingType = null;
        let percentageDiscount = null;
        let keepApplicationFee = null;
        let applyOnHeavy = null;
        let hisLoyaltyStatus = null;
        let hisLoyaltyRenew = null;
        const conditions = JSON.parse(promotion.conditions);
        const actions = JSON.parse(promotion.actions);
        if (!!conditions) {
            const shipping_promotion = conditions.find(c => c.code === "shipping_promotion");
            if (!!shipping_promotion) {
                shippingType = shipping_promotion.args.find(sa => sa.name === "shippingType")?.value;
            }
            const loyalty_condition = conditions.find(c => c.code === 'loyalty');
            if (!!loyalty_condition) {
                const loyaltyStatus = loyalty_condition.args.find(lc => lc.name === "loyaltyStatus")?.value;
                const onLoyaltyRenew = loyalty_condition.args.find(lc => lc.name === "onLoyaltyRenew")?.value;
                hisLoyaltyStatus = loyaltyStatus === "true"
                hisLoyaltyRenew = onLoyaltyRenew === "true"
            }
        }
        if (!!actions) {
            const shipping_discount = actions.find(c => c.code === "shipping_discount");
            if (!!shipping_discount) {
                percentageDiscount = shipping_discount.args.find(sa => sa.name === "percentageDiscount")?.value;
                keepApplicationFee = shipping_discount.args.find(sa => sa.name === "keepApplicationFee")?.value;
                applyOnHeavy = shipping_discount.args.find(sa => sa.name === "applyOnHeavy")?.value;
            }
        }
        if (!!hisLoyaltyStatus && !customer?.customFields?.loyaltyStatus) {
            return null;
        }
        if (!!hisLoyaltyRenew && !customer?.customFields?.loyaltyIsRenew) {
            return null;
        }
        return {
            shippingType: shippingTypeCorrespondance[shippingType],
            percentageDiscount: parseInt(percentageDiscount, 10),
            keepApplicationFee: keepApplicationFee === "true",
            applyOnHeavy: applyOnHeavy === "true",
            conditions,
            actions
        }
    } catch (e) {
        console.error(e);
        return null;
    }
};
const substractPercentage = (value, percentage) => {
    return value - ( value * ( percentage / 100) )
};
const checkMinimumOrder = (conditions, order) => {
    const amount = conditions.args.find(ca => ca.name === 'amount')?.value;
    const withTax = conditions.args.find(ca => ca.name === 'taxInclusive')?.value;
    return withTax === 'true' ? order.totalWithTax >= amount : order.total >= amount ;
};
const checkNWithFacet = (conditions, order) => {
    let count = 0;
    const minimum = conditions.args.find(ca => ca.name === 'minimum')?.value;
    const condFacets = conditions.args.find(ca => ca.name === 'facets')?.value;
    const facets = condFacets.slice(1, -1).split(',');
    for (const line of order.lines) {
        const productFacetIds = line.productVariant.product.facetValues.map(fv => fv.id);
        if (facets.every(f => productFacetIds.includes(f))) count += 1;
    }
    return count >= minimum;
};
const checkContainsProduct = (conditions, order) => {
    let count = 0;
    const minimum = conditions.args.find(ca => ca.name === 'minimum')?.value;
    const condProductVariantIds = conditions.args.find(ca => ca.name === 'productVariantIds')?.value;
    const productVariantIds = condProductVariantIds.slice(1, -1).split(',');
    for (const line of order.lines) {
        if (productVariantIds.find(f => f === line.productVariant.id)) count += 1
    }
    return count >= minimum;
};
const checkOrderQuantity = (conditions, order) => {
    let count = 0;
    const quantity = conditions.args.find(ca => ca.name === 'quantity')?.value;
    for (const line of order.lines) {
        const offers = line.productVariant.customFields.offers.map(o => o.offerType1)
        if (
            ['FID', 'PRI', 'EXT', 'PAUT'].indexOf(line.productVariant.product.customFields.productType) < 0 &&
            (offers.indexOf('PRI') < 0 || offers.indexOf('PAUT') < 0)
        )
            count += line.quantity;
    }
    return count >= quantity;
};
const validatePromotion = (order, promotion) => {
    if (!order) throw new Error('No order passed');
    if (!promotion) throw new Error('No promotion passed');
    let valid = true;
    for (const condition of promotion.conditions) {
        if (!valid) break;
        if (condition.code === "minimum_order_amount") valid = checkMinimumOrder(condition, order);
        if (condition.code === "at_least_n_with_facets") valid = checkNWithFacet(condition, order);
        if (condition.code === "contains_products") valid = checkContainsProduct(condition, order);
        if (condition.code === "order_quantity_promotion") valid = checkOrderQuantity(condition, order);
    }
    return valid;
};
const calculateShippingPromotion = (shippingMethod, promotions, price, isHeavy=false, order) => {
    if (!shippingMethod || !promotions || promotions.length < 0) return price;
    const hasPromotion = promotions.find(p => p.shippingType === shippingMethod.code || p.shippingType === 'tous');

    if (!!hasPromotion && validatePromotion(order, hasPromotion)) {
        if (!hasPromotion.applyOnHeavy && !!isHeavy) return price;
        if (price <= 0) return 0;
        return substractPercentage(price, hasPromotion.percentageDiscount || 0);
    }
    return price;
};
const calculateApplicationFee = (shippingMethod, promotions, order) => {
    if (!shippingMethod || !promotions) return 0;
    const applicationFee = shippingMethod?.customFields?.applicationFee || 0
    const hasPromotion = promotions.find(p => p.shippingType === shippingMethod.code || p.shippingType === 'tous');
    if (!!hasPromotion && validatePromotion(order, hasPromotion))
        return !!hasPromotion.keepApplicationFee ? applicationFee : 0;
    return applicationFee;
};
const getLivraisonMessage = (promotion, shippingMethod, hasLightProduct, order) => {
    const shippingMethodTranslate = {
        "keepApplicationFee" : {
            "mondial-relay": "en livraison en point relais",
            "standard": "en livraison à domicile standard",
            "express": "en livraison express",
            "tous": ""
        },
        "applicationFee100": {
            "mondial-relay": "offerte en point relais",
            "standard": "à domicile standard offerte",
            "express": "express offerte",
            "tous": ""
        },
        "applicationFeeX": {
            "mondial-relay": "en point relais",
            "standard": "à domicile standard",
            "express": "express",
            "tous": ""
        },
        "applicationFee": {
            "mondial-relay": "en point relais offerts",
            "standard": "à domicile standard offerts",
            "express": "express offerts",
            "tous": ""
        },
    };
    if (!promotion || !shippingMethod || !validatePromotion(order, promotion)) return null;
    const shippingType = promotion.shippingType === 'tous' ? 'tous' : shippingMethod.code;
    if (!hasLightProduct && !promotion.applyOnHeavy) return null;
    if (!!promotion.keepApplicationFee) {
        if (promotion.percentageDiscount > 0 && promotion.percentageDiscount <= 100) {
            return `Vous bénéficiez de l'avantage frais de port à l'article ${
                promotion.percentageDiscount >= 100 ? "offerts" : "réduits"} ${
                shippingMethodTranslate["keepApplicationFee"][shippingType]
            }`;
        }
    } else {
        if (promotion.percentageDiscount >= 100) {
            return `Vous bénéficiez de l'avantage livraison ${
                shippingMethodTranslate["applicationFee100"][shippingType]
            }`;
        } else if (promotion.percentageDiscount > 0 && promotion.percentageDiscount < 100) {
            return `Vous bénéficiez de l'avantage réduction sur livraison ${
                shippingMethodTranslate["applicationFeeX"][shippingType]
            }`;
        } else {
            return `Vous bénéficiez de l'avantage frais de livraison ${
                shippingMethodTranslate["applicationFee"][shippingType]
            }`;
        }
    }
};
export {
    shippingTypeCorrespondance,
    getDetails,
    substractPercentage,
    calculateShippingPromotion,
    calculateApplicationFee,
    getLivraisonMessage,
    validatePromotion
};